<template>
<div>
  <dd-text-box
      v-bind="computedProps"
      v-model="innerValue"
      v-on="computedListeners">
    <template v-slot:append>
      <v-btn
        icon
        color="primary"
        dark
        elevation="0"
        small
        v-if="readonlyBtn"
        @click="onDialogButtonClick"
        >
        <v-icon>mdi-magnify-plus</v-icon>
      </v-btn>
    </template>
    <span>発注契約検索用ポップアップを表示します</span>

  </dd-text-box>
  <dd-hacchu-keiyaku-kensaku-dialog
    :showDialog="showDialog"
    @close="onDialogClosed"/>
</div>
</template>
<script>
const DdTextBox = () => import('@/components/DdTextBox')
const DdHacchuKeiyakuKensakuDialog = () => import('@/components/DdHacchuKeiyakuKensakuDialog')

export default {
  name: 'DdHacchuKeiyakuKensakuTextBoxByKeiyakuEdit',
  extends: DdTextBox,
  components: {
    DdTextBox,
    DdHacchuKeiyakuKensakuDialog
  },
  props: {
    /**
     * readonly
     */
    readonlyBtn: Boolean
  },
  data: () => ({
    innerValue: '',
    showDialog: false
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  methods: {
    onDialogButtonClick: function (e) {
      this.showDialog = true
      console.log('dialog opend', e)
    },
    onDialogClosed: function (e) {
      console.log('dialog closed', e, this.showDialog)
      this.showDialog = false
      if (e === undefined) { return }
      this.innerValue = e.id

      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       */
      this.$emit('input', this.innerValue)
    }
  }
}
</script>
<style scoped>
</style>
